import { CircularProgress } from "@mui/material";
import { TotalSales } from "dtos/apiResponses/PurchasesDTO";
import React, { useEffect, useState } from "react";
import { fetchWithJwt } from "utils/apiRequest";
import { SingleVlaueWidget } from "./Components/SingleValue";

export const TotalNumberOfSalesWidget = () => {
  const [value, setValue] = useState<number>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPurchases = async () => {
      try {
        const response = await fetchWithJwt({
          endpoint: "/purchases/totalSales",
          method: "GET",
        });
        const data: TotalSales = await response.json();
        setValue(data.numberOfSales);
      } catch (err) {
        setError("Failed to load total customers.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPurchases();
  }, []);

  if (loading) return <CircularProgress />;
  if (error) return <div>Error: {error}</div>;

  return (
    <SingleVlaueWidget
      title="Total Sales"
      description="total number of sales, excluding application/transaction fees."
      value={value?.toLocaleString()}
    />
  );
};
